import { Component, OnInit } from '@angular/core';
import {until} from 'selenium-webdriver';
import elementIsSelected = until.elementIsSelected;

export class AppComponent {

}

@Component({
  selector: 'app-eins-plus-eins',
  templateUrl: './eins-plus-eins.component.html',
  styleUrls: ['./eins-plus-eins.component.css']
})
export class EinsPlusEinsComponent implements OnInit {
  erster: number;
  zweiter: number;

  hilfe: boolean;
  hilfsaufgabe: string;

  usr_erg: number;
  falsch = 0;
  richtig = 0;
  folge = 0;
  prozent = 0;
  gesamt = 0;

  r_back = 0;
  f_back = 0;

  korrekt: any = {};

  aufgabe: string[] = [];
  ergebnis: number[] = [];

  rand_int: number[] = [];
  rand_return: number;

  bild: any = {};
  bilder: string[] = [];

  t_str: any = {};

  auswahl: boolean[] = [];

  erfolg: boolean;
  programm: boolean;

  i = 0;
  j = 0;
  add_i = 0;

  e: boolean;

  rechnen: boolean;

  alle: boolean;
  gestartet: boolean;
  neuauswahl: boolean;
  neustart: boolean;

  reihen = [
    { name: 'doppel', bez: 'Verdopplungsaufgabe', number: 0, aufgaben: 11, start: 0 },
    { name: 'einfach', bez: 'einfache Aufgaben', number: 1, aufgaben: 37, start: 11 },
    { name: 'verliebt', bez: 'Ergebnis 10 (verliebte Paare)', number: 2, aufgaben: 11, start: 48 },
    { name: 'fünf', bez: 'Ergebnis 5 oder 15', number: 3, aufgaben: 11, start: 59 },
    { name: 'basis', bez: 'immer 5 als Basis', number: 4, aufgaben: 16, start: 70 },
    { name: 'keine', bez: 'keine Gesetzmäßigkeit', number: 5, aufgaben: 40, start: 86 },
  ];

  neueAufgabe() {
    this.i = 0;
    this.j = 0;
    if(this.alle)
    {
      this.rand_return = Math.floor((Math.random() * 71));
    }
    else
    {
      for (this.j = 0; this.j <= 5; this.j++)
      {
        if (this.auswahl[this.j])
        {
          this.add_i = this.reihen[this.j].start;

          this.rand_int[this.i] = Math.floor((Math.random() * this.reihen[this.j].aufgaben + this.add_i) - 1);
          this.i++;
        }
      }
      this.rand_return = this.rand_int[Math.floor((Math.random() * this.i))];
    }
  }

  starten()
  {
    if (!this.auswahl[0] && !this.auswahl[1] && !this.auswahl[2] && !this.auswahl[3] && !this.auswahl[4] && !this.auswahl[5] && !this.alle)
    {
      alert ('Es muss mindestens eine Aufgabenart ausgewählt werden.');
    }
    else
    {
      this.rechnen = false;
      this.neueAufgabe();
      this.gestartet = true;
      this.neuauswahl = false;
      this.neustart = false;
    }
  }

  neubeginn()
  {
    this.rechnen = true;
    this.gestartet = false;
    this.neuauswahl = true;
    this.neustart = true;
    this.korrekt = '';
  }

  neustarten()
  {
    this.korrekt = '';
    this.falsch = 0;
    this.richtig = 0;
    this.prozent = 0;
    this.rechnen = true;
    this.gestartet = false;
    this.neuauswahl = true;
    this.neustart = true;
    this.folge = 0;
  }

  setAlle()
  {
    if (this.alle)
    {
      for (this.j = 0; this.j <= 5; this.j++)
      {
        this.auswahl[this.j] = true;
      }
      this.neueAufgabe();
    }
    else
    {
      for (this.j = 0; this.j <= 5; this.j++)
      {
        this.auswahl[this.j] = false;
      }
    }
  }

  pruefeErgebnis() {
    this.gesamt++;

    if(this.ergebnis[this.rand_return] === (this.usr_erg))
    {
      this.hilfe = false;
      this.hilfsaufgabe = null;
      this.richtig++;
      this.folge++;
      this.korrekt = '';
      this.prozent = Math.floor(this.falsch * 100 / this.gesamt);
      this.r_back = 1;
      this.f_back = 0;
      setTimeout(() => {
        this.r_back = 0;
      }, 200);
      if (this.folge % 5 === 0)
      {
        this.erfolg = false;
        this.programm = true;
        this.bild = this.bilder[Math.floor((Math.random() * 77))];
      }
      else
      {
        this.erfolg = true;
      }
    }
    else
    {
      if (this.hilfe) {
        this.hilfe = false;
        this.hilfsaufgabe = null;
      }
      else {
        // Abfrage, ob Hilfsaufgabe gestellt werden muss
        if (this.rand_return < 11) {
          // Verdopplungsaufgabe - ohne Hilfsaufgabe
          this.hilfe = false;
        }
        else if (this.rand_return < 37 + 11) {
          // einfache Aufgaben - ohne Hilfsaufgabe
          this.hilfe = false;
        }
        else if (this.rand_return < 11 + 37 + 11) {
          // verliebte Paare - ohne Hilfsaufgabe
          this.hilfe = false;
        }
        else if (this.rand_return < 11 + 11 + 37 + 11) {
          // Ergebnis 5 oder 15 - ohne Hilfsaufgabe
          this.hilfe = false;
        }
        else if (this.rand_return < 16 + 11 + 11 + 37 + 11) {
          // immer 5 als Basis - ggf Hilfsaufgabe
          this.hilfe = false;
          if (this.aufgabe[this.rand_return] === '6+5') {
            this.hilfe = true;
            this.hilfsaufgabe = '5+5 und 1 mehr';
          }
          if (this.aufgabe[this.rand_return] === '7+5') {
            this.hilfe = true;
            this.hilfsaufgabe = '5+5 und 2 mehr';
          }
          if (this.aufgabe[this.rand_return] === '8+5') {
            this.hilfe = true;
            this.hilfsaufgabe = '10+5 und 2 weniger';
          }
          if (this.aufgabe[this.rand_return] === '9+5') {
            this.hilfe = true;
            this.hilfsaufgabe = '10+5 und 1 weniger';
          }
          if (this.aufgabe[this.rand_return] === '5+4') {
            this.hilfe = true;
            this.hilfsaufgabe = '5+5 und 1 weniger';
          }
          if (this.aufgabe[this.rand_return] === '5+6') {
            this.hilfe = true;
            this.hilfsaufgabe = '5+5 und 1 mehr';
          }
          if (this.aufgabe[this.rand_return] === '5+7') {
            this.hilfe = true;
            this.hilfsaufgabe = '5+5 und 2 mehr';
          }
          if (this.aufgabe[this.rand_return] === '5+8') {
            this.hilfe = true;
            this.hilfsaufgabe = '5+10 und 2 weniger';
          }
          if (this.aufgabe[this.rand_return] === '5+9') {
            this.hilfe = true;
            this.hilfsaufgabe = '5+10 und 1 weniger';
          }
        }
        else if (this.rand_return < 40 + 16 + 11 + 11 + 37 + 11) {
          // keine Gesetzmäigkeit - ggf Hilfsaufgabe
          this.hilfe = false;
          if (this.aufgabe[this.rand_return] === '2+9') {
            this.hilfe = true;
            this.hilfsaufgabe = '1+9 und 1 mehr';
          }
          if (this.aufgabe[this.rand_return] === '3+9') {
            this.hilfe = true;
            this.hilfsaufgabe = '3+10 und 1 weniger';
          }
          if (this.aufgabe[this.rand_return] === '4+9') {
            this.hilfe = true;
            this.hilfsaufgabe = '4+10 und 1 weniger';
          }
          if (this.aufgabe[this.rand_return] === '7+9') {
            this.hilfe = true;
            this.hilfsaufgabe = '7+10 und 1 weniger';
          }
          if (this.aufgabe[this.rand_return] === '8+9') {
            this.hilfe = true;
            this.hilfsaufgabe = '8+10 und 1 weniger';
          }
          if (this.aufgabe[this.rand_return] === '9+8') {
            this.hilfe = true;
            this.hilfsaufgabe = '10+8 und 1 weniger';
          }
          if (this.aufgabe[this.rand_return] === '9+7') {
            this.hilfe = true;
            this.hilfsaufgabe = '10+7 und 1 weniger';
          }
          if (this.aufgabe[this.rand_return] === '9+4') {
            this.hilfe = true;
            this.hilfsaufgabe = '10+4 und 1 weniger';
          }
          if (this.aufgabe[this.rand_return] === '9+3') {
            this.hilfe = true;
            this.hilfsaufgabe = '10+3 und 1 weniger';
          }
          if (this.aufgabe[this.rand_return] === '9+2') {
            this.hilfe = true;
            this.hilfsaufgabe = '10+2 und 1 weniger';
          }
          if (this.aufgabe[this.rand_return] === '8+3') {
            this.hilfe = true;
            this.hilfsaufgabe = '8+2 und 1 mehr';
          }
          if (this.aufgabe[this.rand_return] === '8+4') {
            this.hilfe = true;
            this.hilfsaufgabe = '8+2 und 2 mehr';
          }
          if (this.aufgabe[this.rand_return] === '8+6') {
            this.hilfe = true;
            this.hilfsaufgabe = '6+6 und 2 mehr';
          }
          if (this.aufgabe[this.rand_return] === '6+8') {
            this.hilfe = true;
            this.hilfsaufgabe = '6+6 und 2 mehr';
          }
          if (this.aufgabe[this.rand_return] === '4+8') {
            this.hilfe = true;
            this.hilfsaufgabe = '2+8 und 2 mehr';
          }
          if (this.aufgabe[this.rand_return] === '3+8') {
            this.hilfe = true;
            this.hilfsaufgabe = '2+8 und 1 mehr';
          }
          if (this.aufgabe[this.rand_return] === '4+3') {
            this.hilfe = true;
            this.hilfsaufgabe = '3+3 und 1 mehr';
          }
          if (this.aufgabe[this.rand_return] === '6+3') {
            this.hilfe = true;
            this.hilfsaufgabe = '6+4 und 1 weniger';
          }
          if (this.aufgabe[this.rand_return] === '7+4') {
            this.hilfe = true;
            this.hilfsaufgabe = '7+3 und 1 mehr';
          }
          if (this.aufgabe[this.rand_return] === '7+6') {
            this.hilfe = true;
            this.hilfsaufgabe = '7+7 und 1 weniger';
          }
          if (this.aufgabe[this.rand_return] === '6+7') {
            this.hilfe = true;
            this.hilfsaufgabe = '7+7 und 1 weniger';
          }
          if (this.aufgabe[this.rand_return] === '4+7') {
            this.hilfe = true;
            this.hilfsaufgabe = '3+7 und 1 mehr';
          }
          if (this.aufgabe[this.rand_return] === '3+4') {
            this.hilfe = true;
            this.hilfsaufgabe = '3+3 und 1 mehr';
          }
        }
        if (this.hilfe) {
          this.korrekt = 'leider falsch: Hilfsaufgabe: ' + this.hilfsaufgabe;
          this.usr_erg = null;
        }
        else {
          this.falsch++;
          this.folge = 0;
          this.korrekt = "richtig wäre: " + this.aufgabe[this.rand_return] + " = " + this.ergebnis[this.rand_return];
          this.prozent = Math.floor(this.falsch * 100 / this.gesamt);
          this.r_back = 0;
          this.f_back = 1;
          setTimeout(() => {
            this.f_back = 0;
          }, 200);
        }
      }
    }

    if(!this.hilfe) {
      this.neueAufgabe();
      this.usr_erg = null;
    }
  }

  weiter()
  {
    this.erfolg = true;
    this.programm = false;
  }

  constructor() {
    const BILD_I = 77;
    const FAKTOR_MAX = 5;

    for(let a = 0; a <= FAKTOR_MAX; a++)
    {
      this.erster = 0;
      this.zweiter = 0;

      // Verdopplungsaufgaben
      if (a === 0) {
        for (let b = 2; b <= this.reihen[a].aufgaben; b++) {
          this.aufgabe.push(`${this.erster}+${this.zweiter}`);
          this.ergebnis.push(this.erster + this.zweiter);
          this.erster = this.erster + 1;
          this.zweiter = this.zweiter + 1;
        }
      }

      // einfache Aufgaben
      if (a === 1) {
        //this.reihen[a].aufgaben = this.reihen[a - 1].aufgaben;
        for (let c = 1; c <= 10; c++) {
          this.aufgabe.push(`0+${c}`);
          this.ergebnis.push(0 + c);
          //this.reihen[a].aufgaben = this.reihen[a].aufgaben + 1;
        }
        for (let c = 1; c <= 9; c++) {
          this.aufgabe.push(`${c}+10`);
          this.ergebnis.push(c + 10);
          //this.reihen[a].aufgaben = this.reihen[a].aufgaben + 1;
        }
        for (let c = 1; c <= 9; c++) {
          this.aufgabe.push(`${c}+0`);
          this.ergebnis.push(c + 0);
          //this.reihen[a].aufgaben = this.reihen[a].aufgaben + 1;
        }
        for (let c = 1; c <= 9; c++) {
          this.aufgabe.push(`10+${c}`);
          this.ergebnis.push(10 + c);
          //this.reihen[a].aufgaben = this.reihen[a].aufgaben + 1;
        }
      }

      // Ergebnis 10 (verliebte Paare)
      if (a === 2) {
        //this.reihen[a].aufgaben = this.reihen[a - 1].aufgaben;
        for (let c = 0, d = 10; c <= 10; c++, d--) {
          this.aufgabe.push(`${c}+${d}`);
          this.ergebnis.push(c + d);
          //this.reihen[a].aufgaben = this.reihen[a].aufgaben + 1;
        }
      }

      // Ergebnis 5 oder 15
      if (a === 3) {
        //this.reihen[a].aufgaben = this.reihen[a - 1].aufgaben;
        for (let c = 0, d = 5; c <= 10; c++, d--) {
          if (d === 0) {
            d = 10;
          }
          this.aufgabe.push(`${c}+${d}`);
          this.ergebnis.push(c + d);
          //this.reihen[a].aufgaben = this.reihen[a].aufgaben + 1;
        }
      }

      // immer 5 als Basis
      if (a === 4) {
        //this.reihen[a].aufgaben = this.reihen[a - 1].aufgaben;
        for (let c = 1; c <= 9; c++) {
          if (c !== 5) {
            this.aufgabe.push(`${c}+5`);
            this.ergebnis.push(c + 5);
            this.aufgabe.push(`5+${c}`);
            this.ergebnis.push(5 + c);
            //this.reihen[a].aufgaben = this.reihen[a].aufgaben + 1;
          }
        }
        for (let c = 1; c <= 9; c++) {
          if (c !== 5) {
            this.aufgabe.push(`5+${c}`);
            this.ergebnis.push(5 + c);
            //this.reihen[a].aufgaben = this.reihen[a].aufgaben + 1;
          }
        }
      }

      // keine Gesetzmäßigkeit
      if (a === 5) {
        //this.reihen[a].aufgaben = this.reihen[a - 1].aufgaben;
        for (let c = 2; c <= 8; c++) {
          if (c !== 4 && c !== 5) {
            this.aufgabe.push(`${c}+1`);
            this.ergebnis.push(c + 1);
            this.aufgabe.push(`1+${c}`);
            this.ergebnis.push(1 + c);
            //this.reihen[a].aufgaben = this.reihen[a].aufgaben + 2;
          }
          if (c !== 5 && c !== 6 ) {
            this.aufgabe.push(`${c}+9`);
            this.ergebnis.push(c + 9);
            this.aufgabe.push(`9+${c}`);
            this.ergebnis.push(9 + c);
            //this.reihen[a].aufgaben = this.reihen[a].aufgaben + 2;
          }
          if (c !== 2 && c !== 3 && c !== 5 && c !== 8) {
            this.aufgabe.push(`${c}+2`);
            this.ergebnis.push(c + 2);
            this.aufgabe.push(`2+${c}`);
            this.ergebnis.push(2 + c);
            //this.reihen[a].aufgaben = this.reihen[a].aufgaben + 2;
          }
          if (c !== 2 && c !== 5 && c !== 7 && c !== 8) {
            this.aufgabe.push(`${c}+8`);
            this.ergebnis.push(c + 8);
            this.aufgabe.push(`8+${c}`);
            this.ergebnis.push(8 + c);
            //this.reihen[a].aufgaben = this.reihen[a].aufgaben + 2;
          }
          if (c !== 2 && c !== 3 && c !== 5 && c !== 7 && c !== 8) {
            this.aufgabe.push(`${c}+3`);
            this.ergebnis.push(c + 3);
            this.aufgabe.push(`3+${c}`);
            this.ergebnis.push(3 + c);
            //this.reihen[a].aufgaben = this.reihen[a].aufgaben + 2;
          }
          if (c !== 2 && c !== 3 && c !== 5 && c !== 7 && c !== 8) {
            this.aufgabe.push(`${c}+7`);
            this.ergebnis.push(c + 7);
            this.aufgabe.push(`7+${c}`);
            this.ergebnis.push(7 + c);
            //this.reihen[a].aufgaben = this.reihen[a].aufgaben + 2;
          }
        }
      }
    }

    for(let b = 0; b <= BILD_I; b++)
    {
      this.t_str = 'images\\' + b + '.jpg';
      this.bilder.push(this.t_str);
    }
  }

  ngOnInit() {
    this.korrekt = '';
    this.rechnen = true;
    this.programm = false;
    this.erfolg = true;

    for (this.j = 2; this.j <= 10; this.j++)
    {
      this.auswahl[this.j] = false;
    }
    this.gestartet = false;
    this.neuauswahl = true;
    this.neustart = true;
    this.erfolg = true;

    this.hilfe = false;
    this.hilfsaufgabe = '';
  }

}



// WEBPACK FOOTER //
// ./src/app/eins-plus-eins/eins-plus-eins.component.ts